import React, {useState} from "react";
import {NavLink, useNavigate} from "react-router-dom";
import {MdDashboard, MdKeyboardArrowDown, MdKeyboardArrowUp} from "react-icons/md";
import {FaCartShopping} from "react-icons/fa6";
import {FaUsers} from "react-icons/fa";
import {Settings} from "@mui/icons-material";
import {Can} from "../../Can";

const SiteDropdownSidebar = ({thememode}) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const handleMainClick = () => {
        // Navigate to the default dashboard page
        navigate("/SiteManagement");
    };

    const handleArrowClick = (e) => {
        e.stopPropagation(); // Prevent triggering the main click
        setIsOpen(!isOpen);
    };

    return (
        <div className="mb-1">
            <div
                className={`flex items-center justify-between p-3 pl-6 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300`}
                onClick={handleMainClick}
            >
                <div className={'flex items-center '}>
                    <Settings className="mr-3"/>
                    <span className="flex-grow">Manage Site</span>
                </div>
                <div
                    className="p-1 hover:bg-gray-300 dark:hover:bg-gray-600 rounded"
                    onClick={handleArrowClick}
                >
                    {isOpen ? <MdKeyboardArrowUp/> : <MdKeyboardArrowDown/>}
                </div>
            </div>

            {isOpen && (
                <div>
                    <Can I="index" a="sliders">
                    <NavLink
                        to="/Sliders"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Sliders</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="faqs">
                    <NavLink
                        to="/Faqs"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Faqs</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="settings">
                    <NavLink
                        to="/Settings"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Settings</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="emailProviders">
                    <NavLink
                        to="/EmailProviders"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Email Providers</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="emailTemplates">
                    <NavLink
                        to="/EmailTemplates"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Email Templates</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="smmticket">
                    <NavLink
                        to="/Smm-ticket-profile"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Smm Ticket Profile</span>
                    </NavLink>
                    </Can>

                </div>
            )}
        </div>
    );
};

export default SiteDropdownSidebar;